import React, { useEffect, useState } from "react";
import { Phone, ArrowLeft } from "lucide-react";

// Image
import imnmage4 from "../../assets/images/header/Screenshot_2025-04-09_134108-removebg-preview.png";

const Home = () => {
  const [clip, setClip] = useState("");
  const [clipStyle, setClipStyle] = useState(1);
  
  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleResize = () => {
        if (window.innerWidth >= 768) {
          // انتخاب سبک‌های مختلف برای clip بر اساس حالت انتخاب شده
          const clips = [
            "polygon(0 0, 100% 0, 100% 90%, 70% 100%, 0 90%)", // سبک 1: زاویه دار مدرن
            "polygon(0 0, 100% 0, 100% 90%, 85% 100%, 0 90%)", // سبک 2: زاویه ملایم‌تر
            "polygon(0 0, 100% 0, 100% 85%, 90% 90%, 50% 100%, 0 90%)", // سبک 3: موج دار
            "polygon(0 0, 100% 0, 100% 90%, 0 100%)", // سبک 4: مورب ساده
            "polygon(0 0, 100% 0, 100% 90%, 90% 95%, 70% 90%, 40% 100%, 0 90%)" // سبک 5: چندضلعی مدرن
          ];
          setClip(clips[clipStyle] || clips[0]);
        } else {
          setClip("none");
        }
      };

      handleResize();
      window.addEventListener("resize", handleResize);

      return () => window.removeEventListener("resize", handleResize);
    }
  }, [clipStyle]);

  return (
    <React.Fragment>
      <style>
        {`
          @keyframes float {
            0% { transform: translateY(0px); }
            50% { transform: translateY(-15px); }
            100% { transform: translateY(0px); }
          }
          
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
          
          .gradient-bg {
            background: linear-gradient(135deg, #302b3b 0%, #3b1f7b 50%, #32245b 100%);
          }
          
          .glass-effect {
            background: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255, 255, 255, 0.2);
          }
          
          .btn-hover-effect {
            transition: all 0.3s ease;
            position: relative;
            overflow: hidden;
          }
          
          .btn-hover-effect:before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
            transition: all 0.6s ease;
          }
          
          .btn-hover-effect:hover:before {
            left: 100%;
          }

          .clip-selector {
            position: absolute;
            bottom: 20px;
            left: 20px;
            display: flex;
            gap: 10px;
            z-index: 30;
          }
          
          .clip-option {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            cursor: pointer;
            border: 2px solid white;
            transition: all 0.3s ease;
          }
          
          .clip-option.active {
            transform: scale(1.2);
            box-shadow: 0 0 10px rgba(255, 255, 255, 0.8);
          }
        `}
      </style>
      
      <section
        className="relative pb-28 skewed gradient-bg xl:pb-20 pt-20 xl:pt-32 overflow-hidden"
        id="home"
        style={{ clipPath: clip }}
      >
        {/* انتخاب‌گر سبک کراپ (فقط در حالت توسعه) */}
     

        {/* Decorative elements */}
        <div className="absolute top-0 left-0 size-64 opacity-10 blur-3xl"></div>
        <div className="absolute bottom-0 right-0 size-64 bg-purple-500/10 blur-3xl"></div>
        
        {/* Animated circles */}
        <div className="absolute top-1/4 left-10 w-72 h-72 rounded-full bg-white/5 animate-pulse"></div>
        <div className="absolute bottom-20 right-1/4 w-40 h-40 rounded-full bg-white/5 animate-pulse delay-700"></div>
        
        <div className="container 2xl:max-w-[87.5rem] px-4 mx-auto relative z-10">
          <div className="grid items-center grid-cols-12 gap-8 2xl:grid-cols-12">
            {/* Image section */}
            <div className="col-span-12 xl:col-span-7 2xl:col-start-1 2xl:col-span-6">
              <div className="relative mt-10 xl:mt-0 h-[450px] flex justify-center">
                <img
                  src={imnmage4}
                  style={{ animation: "float 3s ease-in-out infinite" }}
                  alt="نفر ایستاده"
                  className="relative z-20 h-96 max-w-full object-contain"
                  data-aos="zoom-in"
                  data-aos-delay="1000"
                />
                
                {/* Decorative elements around image */}
                <div className="absolute -bottom-5 -left-5 w-32 h-32 rounded-full bg-yellow-400/20 blur-xl"></div>
                <div className="absolute -top-5 -right-5 w-24 h-24 rounded-full bg-purple-300/30 blur-xl"></div>
              </div>
            </div>

            {/* Text content */}
            <div className="col-span-12 xl:col-span-5 2xl:col-span-5 text-right flex flex-col justify-center">
              <div className="glass-effect rounded-2xl p-8 shadow-xl" data-aos="fade-left">
                <h4
                  className="mb-4 !leading-normal lg:text-4xl font-bold text-white bg-gradient-to-r from-white to-purple-100 bg-clip-text text-transparent"
                  data-aos="fade-right"
                  data-aos-delay="300"
                >
                  سامانه پیمانکاران چغندرقند هاویر کشت
                </h4>
                
                <div className="space-y-4 mb-8">
                  <div className="flex items-center justify-end gap-3" data-aos="fade-right" data-aos-delay="400">
                    <span className="text-white text-lg">سجاد رشنو - شماره پیمان ۱۱۵۴۰ :پیمانکار</span>
                    <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
                      <span className="text-white font-bold">✓</span>
                    </div>
                  </div>
                  
                  <div className="flex items-center justify-end gap-3" data-aos="fade-right" data-aos-delay="500">
                    <span className="text-white text-lg">شرکت هوشمند پرداز هاویر</span>
                    <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
                      <span className="text-white font-bold">🏢</span>
                    </div>
                  </div>
                </div>
                
                <div className="text-right" data-aos="fade-up" data-aos-delay="700">
                  <a href="#contact" className="inline-block">
                    <button
                      type="button"
                      className="px-8 py-4 text-white text-lg font-bold btn-hover-effect rounded-full glass-effect flex items-center justify-center gap-2 hover:shadow-lg hover:scale-105 transition-all duration-300"
                    >
                      <Phone size={20} />
                      تماس با ما
                      <ArrowLeft size={20} />
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Home;